import {connect} from 'react-redux'

import type {State} from '../../../../../reducers/types'
import {getBuild} from '../../../../../selectors'
import type {BuildId, ChangeId, BuildTypeId} from '../../../../../types'

import BuildStatusTooltip from './BuildStatusTooltip'
import {getPersonalChangeId} from './BuildStatusTooltip.selectors'

type OwnProps = {
  buildId: BuildId
}
type StateProps = {
  changeId: ChangeId | null | undefined
  buildTypeId?: BuildTypeId | null | undefined
}

const mapStateToProps = (state: State, {buildId}: OwnProps): StateProps => {
  const {buildType} = getBuild(state, buildId) || {}
  return {
    changeId: getPersonalChangeId(state, buildId),
    buildTypeId: buildType,
  }
}

export default connect(mapStateToProps)(BuildStatusTooltip)
